import classes from './AppLayout.module.scss';
import { Header } from './header/index.ts';
import { Sidebar } from './sidebar/index.ts';
import { useLayout } from '#layout/Layout.context.ts';
import type { TAppLayoutProps } from '#layout/Layout.types.ts';
import { Footer } from '#layout/shared/footer/index.ts';

export const AppLayout = ({ attachAside, children }: TAppLayoutProps) => {
  const { isRegular } = useLayout();

  return (
    <div className={classes['app-layout']}>
      {isRegular ? null : <Header />}
      <Sidebar />
      <main className={classes.main}>{children}</main>
      {isRegular ? <div ref={attachAside} className={classes.aside} /> : null}
      <Footer className={classes.footer} />
    </div>
  );
};
